<footer>
    <p>newsjunky.ie &copy;2021</p> 
    <p><i class="material-icons">email</i> info@newsjunky.ie</p>
    <p><span class="iconify" data-icon="mdi-twitter" data-inline="false"></span><a href="https://twitter.com/NewsjunkyI">@NewsjunkyI</a></p>
    <p><a routerLink="/about" routerLinkActive="mat-accent">About</a></p>
    <p><a routerLink="/privacy" routerLinkActive="mat-accent">Privacy</a></p>
 
</footer>
